module.exports = __webpack_public_path__ + "static/img/empty-scan-icon.5bd42124.png";